const consultation = require("./consultation");

module.exports = {
    name: "Anglian Water - Lincolnshire Reservoir",

    base: {
		contact_address: "Freepost Lincolnshire Reservoir",
		contact_number: "0800 915 2491",
		contact_email: "info@lincsreservoir.co.uk",
	},

    meta: {
		defaultSocialImage: "/assets/images/social.jpg",
		author: "",
		description: "",
		gtag: "",
		gtm: "",
	},

	consultation: {
		"countdown_end": "08/09/2024 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

	}
}